import moment from 'moment'

const provider = getProvider()

function getProvider() {
  // load up the global config
  let config = sightmapConfig(moment)

  const {
    analyticsProvider
  } = config

  let provider = null

  switch (analyticsProvider) {
    case 'google-analytics':
    case undefined:
      if (typeof ga === 'function') {
        provider = 'google-analytics'
      }
      break
  }

  return provider
}

export const trackEvent = ({category, action, label}) => {
  switch (provider) {
    case null:
      break
    case 'google-analytics':
      ga('send', {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
      })
      break
  }
}
